export default function Settings() {
  return (
    <div>
      <h2 className="text-lg font-semibold text-text_primary mb-1">Settings</h2>
      <p className="text-sm text-text_muted">Configure SendGrid, domains, and preferences.</p>
    </div>
  );
}
